<template>
    <div :class="'mb-3 ' + computed_col">
        <div class="text-center db-text">
            <div :class="colorHover">
                <i v-if="icon != ''" :class="computed_icon + ' d-block text-'+color"></i>
                <span :class="'text-truncate text-'+color">{{title}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'title',
        'icon',
        'color',
        'colorHover',
    ],
    computed: {
        computed_col() {
            if(this.col == undefined) {
                return 'col-xs-12 col-sm-6 col-md-4 col-lg-3';
            } else if(this.col == 'auto') {
                return 'col';
            } else if(this.col == 'false') {
                return '';
            } else {
                this.col;
            }
        },
        computed_icon() {
            if(this.icon == undefined) {
                return '';
            } else {
                if(this.icon.includes('fas fa-') || this.icon.includes('far fa-')) {
                    return this.icon;
                } else {
                    return 'fas fa-'+this.icon;
                }
            }
        },
    }
}
</script>